
<mat-dialog-content data-testid="on-hold-popup" class="mat-dialog-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Select on hold data</h4><i data-testid="on-hold-popup-close" class="fas fa-times pull-right fontL3" (click)="hideModal()"></i>
  </div>
  <form class="modal-body mt-0 flex" #ONHOLD_FORM="ngForm">
    <div class="col-xs-8" *ngIf="data.onHoldType === OnHoldProductsInputOnHoldTypeEnum.TICKET">
      <div class="col-xs-12">
        <label>Select ticket for which products are being put on hold</label>
        <div class="col-xs-12">
          <div *ngFor="let ticket of tickets">
            <div class="col-xs-12">
              <label data-testid="on-hold-ticket" class="custom-checkbox flex">
                <input
                  type="radio"
                  name="selectedTicketId"
                  [value]="ticket.id"
                  [(ngModel)]="selectedTicketId"
                  required
                />
                <span class="checkmark"></span>
                <span class="ml-2">{{ticket.get('titleLanguageString')?.get('en') || ticket.get('title')}} ({{ticket.get('ticketNumber')}})
                  <span class="ml-2">allocated to {{ticket.get('allocatedDoctor')?.get('username')}}</span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-4 flex-grow-1">
      <label>Add number of days for which products are being put on hold</label>
      <div class="col-xs-12">
        <input type="number" [(ngModel)]="numberOfDays" name="numberOfDays" required />
      </div>
    </div>
  </form>
  <div class="modal-footer">
    <button class="pull-right" (click)="save()" [disabled]="!ONHOLD_FORM.valid">Save</button>
  </div>
</mat-dialog-content>
